import { render } from "./ToastAlert.vue?vue&type=template&id=644a3160&ts=true"
import script from "./ToastAlert.vue?vue&type=script&lang=ts"
export * from "./ToastAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__